<template>
    <header class="header-holder col m-auto">
      <div class="row">
      <!-- <div @click="location.href='//manchestervoices.org'" class="logo-left col-sm-12 col-md-6 py-4"> -->
      <div @click="goToHomepage()" class="logo-left col-sm-12 col-md-6 py-4">
        <img class="logo" src="../assets/logo.png" alt="logo.png">
      </div>
      <div class="logo-right col-sm-12 col-md-6 py-4">
        <img class="icons" src="../assets/icons.png" alt="logo.png">
      </div>
      </div>

    </header>
</template>

<script>

export default {
  name: "Header",
  props: {
    msg: String
  },
  methods: {
    goToHomepage(){
      window.location = '//manchestervoices.org/'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo{
  /* background-color: red; */
  width: 250px;
}
.icons{
  /* background-color: red; */
  width: 250px;
}
.header{
  height: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
